import AddMaps from "@/components/Elemnt/Maps/AddMaps";
import { useParams } from "react-router";

const AddMapsPage = () => {
  const { appToken = "" } = useParams();
  return <AddMaps appToken={appToken} />;
};

export default AddMapsPage;
